import { useMemo } from 'react';

import { FORM_OPTIONS } from '@context/stock/buysell';
import useAjaibConfig from '@hooks/useAjaibConfig';
import stockService from '@services/stock';

import { CONST_MT_MULTIPLIER } from '../../constants';
import { checkMtAutoFlag, getMtAutoOrderTypes } from '../../featureFlags';

const useGetAccountTypeOptions = (code) => {
  const { config } = useAjaibConfig();

  const mtAutoFlag = config?.enable_ato_mt_web;
  const isMtAutoOn = checkMtAutoFlag(mtAutoFlag);

  const { isMtActive } = stockService.account.mt.status.useMtAccountStatus();
  const { isDtActive } = stockService.account.dt.status.useDtAccountStatus();
  const { data: dtMultipliers } = stockService.detail.dt.multiplier.useDtMultiplier();
  const { isTradeable: isDtTradeable } = stockService.detail.dt.tradeable.useDtTradeable(code);
  const { isTradeable: isMtTradeable } = stockService.detail.mt.tradeable.useMtTradeable(code);

  const accountTypeOptions = useMemo(() => {
    const opt = [];
    FORM_OPTIONS.ACCOUNT_TYPE.forEach((v) => {
      switch (v.value) {
        case 'REGULAR':
          opt.push(v);
          break;
        case 'DAY_TRADING':
          if (isDtActive) {
            opt.push({
              ...v,
              multiplier: isDtTradeable ? dtMultipliers?.[code]?.toString() : null,
            });
          }
          break;
        case 'MARGIN_TRADING':
          if (isMtActive) {
            opt.push({
              ...v,
              multiplier: isMtTradeable ? CONST_MT_MULTIPLIER?.toString() : null,
              orderTypes: getMtAutoOrderTypes(isMtAutoOn, v.orderTypes),
            });
          }
          break;
        default:
          break;
      }
    });
    return opt;
  }, [code, isDtActive, isDtTradeable, dtMultipliers, isMtActive, isMtTradeable, isMtAutoOn]);

  return { accountTypeOptions };
};

export default useGetAccountTypeOptions;
